import * as React from 'react'

import { Box, SearchField, type SortDirection, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { QuestionGroups } from 'modules/reviews/store/collections/questionGroups'
import type Review from 'modules/reviews/store/models/v2/Review'

import Body from './Body'
import Header from './Header'

interface Props {
  form: Review
}

function WriteReviewsTable({ form }: Props) {
  const { access } = useCurrentSession()
  const accessId = access.id
  const formId = form.attributes.id

  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const questionGroups = useLazyRef(() => new QuestionGroups([])).current
  const { loading } = useAsyncData(
    async () =>
      questionGroups.fetch({
        data: {
          surveys_form_id: formId,
          respondent_id: accessId,
        },
      }),
    [formId, accessId]
  )

  const [direction, setDirection] = React.useState<SortDirection>('asc')
  const [attribute, setAttribute] = React.useState<string>('reviewer')

  const onSort = (attribute: string, direction: SortDirection) => {
    setDirection(direction)
    setAttribute(attribute)
  }

  const TableOptions = () => (
    <Box flexGrow>
      <SearchField
        variant="big"
        search={search}
        onSearch={onSearch}
        placeholder={i18n.t('common.search')}
      />
    </Box>
  )

  return (
    <Table options={TableOptions}>
      <Header onSort={onSort} attribute={attribute} direction={direction} />
      <Body
        search={debouncedSearch}
        questionGroups={questionGroups.toArray()}
        loading={loading}
        attribute={attribute}
        direction={direction}
      />
    </Table>
  )
}

export default observer(WriteReviewsTable)
